var $headerAffixBar = $('#header-affix-bar');

$headerAffixBar
.affix({
  offset: {
    top: $headerAffixBar.position().top
  }
});



/** WEBPACK FOOTER **
 ** /Users/dlopuch/developer/projects-venture-dealr/~/jshint-loader!./views/headerAffixSpy.js
 **/